import { observer } from "mobx-react";
import Card from "../../../../components/layouts/card/card";
import FontHeading2 from "../../../../components/fonts/font-heading2/font-heading2";
import currentPortalStore from "../../../../stores/current-portal-store";
import { FONT_COLOR, FONT_VARIANT } from "../../../../components/fonts/font-props";
import "./rma-counters-card.scss";
import useDashboardTranslation from "../../../../dashboard-translation/hooks/dashboard-translation-hook";
import dashboardTranslationsStore from "../../../../dashboard-translation/stores/dashboard-translations-store";
import RmaLine from "./rma-line/rma-line";
import FontBody1 from "../../../../components/fonts/font-body1/font-body1";
import AHref from "../../../../components/ahref/ahref";
import config from "../../../../config";
import dashboardStore from "../../stores/dashboard-store";
import rmsMixpanelStore from "../../../../stores/rms-mixpanel-store";


const RMACountersCard: React.FC = observer(() => {
    const { getTranslation } = useDashboardTranslation();
    const isLoading = currentPortalStore.isLoading || dashboardTranslationsStore.isLoading || dashboardStore.isLoading;
    const isMerchantOnboarded = !!currentPortalStore.setting?.isMerchantOnboarded;

    const handleViewAllReturnsClick = (e: React.MouseEvent) => {
        rmsMixpanelStore.trackEvent('d&_home_view_all_returns');
        // Let the link work as normal (no preventDefault)
    };

    return (
        <Card
            isLoading={isLoading}
        >
            <FontHeading2 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.PRIMARY3}>
                {getTranslation('MANAGE_RETURNS_TITLE', 'dashboard-home')}
            </FontHeading2>
            {isMerchantOnboarded && (
                <FontBody1>{getTranslation('MANAGE_RETURNS_TROUGH', 'dashboard-home')}
                    <AHref
                        href={`${config.apiUrl}/dashboard/returns`}
                        target="_parent"
                    >
                        <span onClick={handleViewAllReturnsClick}>
                            <FontBody1 color={FONT_COLOR.ACCENT1}>
                                {getTranslation('VIEW_ALL_RETURNS', 'dashboard-home')}
                            </FontBody1>
                        </span>
                    </AHref>
                </FontBody1>
            )}
            <div className={`manage-returns-content ${!isMerchantOnboarded ? 'disabled' : ''}`}>
                {!isLoading && (
                    <>
                        {dashboardStore.rmaCounters.map((counterStore) => (
                            <RmaLine
                                counterStore={counterStore}
                                key={counterStore.name}
                            />
                        ))}
                    </>
                )}
            </div>
        </Card>
    );
});

export default RMACountersCard;
